import { fromJS, Map } from 'immutable';
import Actions from 'flow/actions';
import { listToMap } from 'flow/utils';

const initialState = Map();

const integrationAccessReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE:
            return initialState;
        case Actions.RESULT_INTEGRATION_ACCESS_TOKENS: {
            const integrationAccessTokens = listToMap(
                fromJS(action.data),
                (e) => e.get('key'),
            );
            return state.set('tokens', integrationAccessTokens);
        }
        case Actions.RESULT_INTEGRATION_ACCESS_DOMAINS: {
            const integrationAccessDomains = listToMap(
                fromJS(action.data),
                (e) => e.get('key'),
            );
            return state.set('domains', integrationAccessDomains);
        }
        case Actions.RESULT_CREATE_INTEGRATION_ACCESS_TOKEN: {
            return state
                .setIn(
                    ['tokens', action.integrationAccessKey],
                    fromJS(action.data),
                )
                .set('createdToken', fromJS(action.data));
        }
        case Actions.CLEAR_CREATED_ACCESS_TOKEN: {
            return state.set('createdToken', null);
        }
        default: {
            return state;
        }
    }
};

export default integrationAccessReducer;
